angular.module('filters')
  .filter 'ordinal', -> (input) ->
    if not input? or isNaN(input)
      return input

    if input % 100 >= 11 and input % 100 <= 13
      return "#{input}th"

    suffixes = ["th", "st", "nd", "rd"]
    suffix = suffixes[input % 10] or "th"
    "#{input}#{suffix}"
